import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast";
import MUIDataTable from 'mui-datatables';
import CircularProgress from "@mui/material/CircularProgress";

const QuickServiceDetails = (props) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');

    const [ticketData, setTicketData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const options = {
        tableBodyHeight: '50vh',
        filter: false,
        responsive: 'vertical',
        serverSide: false,
        download: false,
        viewColumns: false,
        jumpToPage: true,
        selectableRows: 'none',
        print: false,
        rowsPerPage: rowsPerPage,
        onChangeRowsPerPage: (n) => {
            setRowsPerPage(n)
        },
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        search: true,
        searchPlaceholder: 'Search tickets...'
    };

    const columns = [
        {
            label: 'Ticket Number',
            name: 'ticketNumber',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return <strong>{value || 'N/A'}</strong>;
                }
            }
        },
        {
            label: 'Issued Time',
            name: 'issuedTime',
            options: {
                sort: true,
                filter: false
            }
        },
        {
            label: 'Category',
            name: 'category',
            options: {
                sort: true,
                filter: false
            }
        },
        {
            label: 'Mobile',
            name: 'mobile',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return value || 'N/A';
                }
            }
        },
        {
            label: 'Language',
            name: 'language',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    if (!value) return 'N/A';
                    const languageMap = {
                        '1': 'English',
                        '2': 'Sinhala',
                        '3': 'Tamil',
                        1: 'English',
                        2: 'Sinhala',
                        3: 'Tamil'
                    };
                    return languageMap[value] || value;
                }
            }
        },
        {
            label: 'Transfer Type',
            name: 'transferType',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return value || 'N/A';
                }
            }
        },
        {
            label: 'Service Start Time',
            name: 'serviceStartTime',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return value || 'N/A';
                }
            }
        },
        {
            label: 'Service End Time',
            name: 'serviceEndTime',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return value || 'N/A';
                }
            }
        },
        {
            label: 'Service Time',
            name: 'serviceTime',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return <strong>{value || 'N/A'}</strong>;
                }
            }
        },
        {
            label: 'Counter',
            name: 'counterNumber',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return value || 'N/A';
                }
            }
        },
        {
            label: 'Teller',
            name: 'tellerName',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => {
                    return value || 'N/A';
                }
            }
        }
    ];

    // Fetch quick service ticket details
    const getQuickServiceTicketDetails = () => {
        setLoading(true);
        axios({
            method: 'GET',
            url: `${baseUrl}/ticket/ticket-details-service-time-less-than-one-minute/branch/${props.selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            console.log('getQuickServiceTicketDetails success', res.data);
            if (res.data && (res.data.status === 'ok' || res.data.message === 'success') && res.data.data) {
                // Sort by issued time (newest first) - assuming issuedTime is in HH:mm:ss format
                const sortedData = [...res.data.data].sort((a, b) => {
                    if (!a.issuedTime || !b.issuedTime) return 0;
                    return b.issuedTime.localeCompare(a.issuedTime);
                });
                setTicketData(sortedData);
            } else {
                setTicketData([]);
            }
            setLoading(false);
        }).catch((error) => {
            console.log('getQuickServiceTicketDetails error');
            console.log(error);
            setTicketData([]);
            setLoading(false);
            
            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message || 'Failed to fetch express service ticket details', {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        });
    };

    useEffect(() => {
        if (props.showQuickServiceDetails && props.selectedBranchId) {
            getQuickServiceTicketDetails();
        }
    }, [props.showQuickServiceDetails, props.selectedBranchId]);

    // Prepare table data
    const tableData = ticketData.map((item) => [
        item.ticketNumber || 'N/A',
        item.issuedTime || 'N/A',
        item.category || 'N/A',
        item.mobile || 'N/A',
        item.language || 'N/A',
        item.transferType || 'N/A',
        item.serviceStartTime || 'N/A',
        item.serviceEndTime || 'N/A',
        item.serviceTime || 'N/A',
        item.counterNumber || 'N/A',
        item.tellerName || 'N/A'
    ]);

    return (
        <>
            {props.showQuickServiceDetails && (
                <div className={`modal fade d-block show modal-container`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl" style={{ marginTop: '3%' }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Express Service Tickets (Service Time &lt; 1 Minute)</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => {
                                        props.setShowQuickServiceDetails(false);
                                        props.setSticky(false);
                                    }}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {isLoading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                                        <CircularProgress />
                                    </div>
                                ) : ticketData.length > 0 ? (
                                    <MUIDataTable
                                        title=""
                                        data={tableData}
                                        columns={columns}
                                        options={options}
                                    />
                                ) : (
                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                        <p>No tickets with service time less than 1 minute</p>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        props.setShowQuickServiceDetails(false);
                                        props.setSticky(false);
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Toaster />
        </>
    );
};

export default QuickServiceDetails;

